<template>
	<div ref="pdfDom">
		<reportLayout @downloadPDF="downloadPDF" :mainTitle="generalTable[0].schoolName" secondTitle="班级对比报告">
			<template>
				<div class="pt-10 pd-10">
					<span class="level-two">考试总概况</span>&nbsp;&nbsp;
					<span class="level-four">可查看所选择的考试整体的数据情况。</span>
				</div>
				<el-table :data="generalTable" style="width: 100%" border stripe>
					<el-table-column prop="beginTime" label="考试时间" width="110" align="center"></el-table-column>
					<el-table-column prop="examName" label="考试名称" width="260" align="center"></el-table-column>
					<el-table-column prop="examRangeName" label="考试类型" align="center"> </el-table-column>
					<el-table-column prop="examStudentNumber" label="总人数" align="center"> </el-table-column>
					<el-table-column prop="fullScore" label="考试满分" align="center"> </el-table-column>
					<el-table-column prop="fullScoreStudentNumber" label="满分人数" align="center"> </el-table-column>
					<el-table-column prop="missStudentNumber" label="缺考人数" align="center"> </el-table-column>
					<el-table-column prop="maxScore" label="最高分" align="center"> </el-table-column>
					<el-table-column prop="minScore" label="最低分" align="center"> </el-table-column>
					<el-table-column prop="avgScore" label="平均分" align="center"> </el-table-column>
				</el-table>
				<div class="constract" v-for="(item, index) in analysis" :key="index">
					<div class="level-two pt-10 pd-5">{{ item.tableData.subName }}标准分分析对比：</div>
					<vueEcharts class="line-charts" :options="item.echarts"></vueEcharts>
					<div class="level-five pt-10 pd-10">
						注：因每场考试的难易程度以及各学科性质不同，所以我们使用标准分更加科学和合理的呈现出成绩的趋势走向。
						标准分为正值表现高于平均分，标准分为负值表现低于平均分，标准分为“0”表示为和平均分相等或未参加考试。
						标准分：是通过原始分转换而得到的一种地位数量，它反应当前群体成绩在全部群体成绩之中的变化情况。
						平均分：平均分趋势图仅供参考，要保证数据更具有参考及对比的价值，建议查看标准分趋势图对比查看
					</div>
					<div class="level-three pt-10 pd-10">{{ item.tableData.subName }}数据详细分析</div>
					<analysis-table :info="item.tableData.examInfoDTOList" :subName="item.tableData.subName"></analysis-table>
					<div class="level-five pt-10 pd-10 lh-25">
						超均率：超均率是反应某群体的分数值超出（或低于）整体水平程度的数值。比如：个人或集体的超均率＝（个人或集体的平均分－全区总的平均分）/全区总的平均分。
						<br />
						综上说明：
						<br />
						根据 {{ item.tableData.examInfoDTOList.length }}场考试数据分析， 从{{ item.tableData.examInfoDTOList[0].beginTime }} 到
						{{ `${item.tableData.examInfoDTOList[item.tableData.examInfoDTOList.length - 1].beginTime}` }}
						{{ item.tableData.examInfoDTOList[0].examName }}考试考试排名变化中，
						{{item.tableData.riseClassName}}
						语文排名在各班级中排名上升最多（{{ item.tableData.riseRank }}名）。
						<br />
						根据{{ item.tableData.examInfoDTOList.length }}场考试数据分析， 从{{ item.tableData.examInfoDTOList[0].beginTime }} 到
						{{ `${item.tableData.examInfoDTOList[item.tableData.examInfoDTOList.length - 1].beginTime}` }}
						{{ item.tableData.examInfoDTOList[0].examName }}考试考试排名变化中，
						{{item.tableData.descendClassName }}
						语文排名在各班级中排名下降最多（{{ item.tableData.descendRank }}名）。
					</div>
				</div>
				<div>
					<div class="level-two pt-15  pd-5">学科贡献率分析对比：</div>
					<div class="level-six pd-5">通过学科贡献率对比，可查看每个班级每个学科多次考试的贡献情况。</div>
					<div class="level-six pd-5">注：学科贡献率分为正值和负值；正值越大，表示该学科越好，负值的绝对值越大，表示该学科越不好。</div>
					<div v-for="item in contributeList" :key="item.className">
						<div class="level-four pd-10 pt-10 ">{{ item.className }}</div>
						<contribute-table :info="item.examInfoDTOS"></contribute-table>
					</div>
				</div>
				<div>
					<div class="level-two pt-15  pd-5">命题质量分析对比：</div>
					<div class="level-six  pd-5">通过命题质量分析，可查看每次考试命题的难易程度和基本指标情况以及难易题目数量：</div>

					<el-table :data="qualityTable" style="width: 100%" border stripe>
						<el-table-column prop="subName" label="科目" align="center"></el-table-column>
						<el-table-column prop="beginTime" label="时间" align="center"></el-table-column>
						<el-table-column prop="difficulty" label="难度" align="center" width="100"> </el-table-column>
						<el-table-column prop="avgScore" label="平均分" align="center" width="100"> </el-table-column>
						<el-table-column prop="standardDeviation" label="标准差" align="center" width="100"> </el-table-column>
						<el-table-column prop="discrimination" label="区分度" align="center" width="100"> </el-table-column>
						<el-table-column prop="sendPointsQuestion" label="送分题数量" align="center"> </el-table-column>
						<el-table-column prop="badQuestion" label="命题不好的题目数量" align="center"> </el-table-column>
					</el-table>
					<div class="level-six pt-10  pd-5">
						说明： 送分题：指区分度在 [0～0.2] ，得分率在 [0.8～1] 区间的试题，绝大部分的学生均作答； 命题不好的题目：指区分度在 [0～0.2] ，得分率在
						[0～0.2] 区间的试题，代表绝大部分学生均不得分。
					</div>
				</div>
				<div>
					<div class="level-two pt-15  pd-5">进退榜分析对比</div>
					<div v-for="item in advanceTable" :key="item.subCode">
						<div class="level-four  pd-5">{{ item.subName }}</div>
						<advanceTable :info="item.classInfoDTO"></advanceTable>
						<div class="level-six pt-10  pd-5">
							综上说明：<br />
							{{ item.schoolName }}考试对比可看出：进步最明显的为{{ item.maxName }}班，相比上次{{ item.max }}名,
							退步最明显的为 {{ item.minName }}班，相比上次{{ item.min }}名；
						</div>
					</div>
				</div>
			</template>
		</reportLayout>
	</div>
</template>

<script>
import reportLayout from '@/views/report/utils/components/report-layout'
import cookies from '@/utils/cookie'
import historyGeneral from '@/views/report/utils/mixin/history-general'
import historyAnalysis from '@/views/report/utils/mixin/history-analysis'
import historyContribute from '@/views/report/utils/mixin/hsitory-contribute'
import historyQuality from '@/views/report/utils/mixin/history-quality'
import historyAdvance from '@/views/report/utils/mixin/history-advance'
export default {
	name: 'index',
	mixins: [historyGeneral, historyAnalysis, historyContribute, historyQuality, historyAdvance],
	components: {
		reportLayout,
		vueEcharts: () => import('vue-echarts'),
		analysisTable: () => import('../utils/components/history/analysis-table'),
		contributeTable: () => import('../utils/components/history/contribute-table'),
		advanceTable: () => import('../utils/components/history/advance-table')
	},
	data() {
		return {
			query: this.$route.query,
			params: {}
		}
	},
	beforeCreate() {
		cookies.set('token', this.$route.query.token)
	},
	created() {
		this.params = {
			examIds: this.query.examIds,
			schoolId: this.query.schoolId
		}
		this.$screenRation()
	},
	methods: {
		downloadPDF() {
			this.$print(this.$refs['pdfDom'])
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/style';
.constract {
	.line-charts {
		width: 100%;
	}
}
</style>
